import { render, staticRenderFns } from "./LeaveFile.vue?vue&type=template&id=70445555"
import script from "./LeaveFile.vue?vue&type=script&lang=js"
export * from "./LeaveFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports